<template>
<div class="form-group">
    <label>{{ name }} <span
v-if="required"
class="text-danger">*</span></label>
    <input
    id="passwordRequirements"
    v-model="password"
    :class="validateInput(password, /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/)"
    class="form-control"
    type="password"
    name="new-password"
    autocomplete="new-password"
    maxlength="128">
    <b-popover
    triggers="focus"
    target="passwordRequirements"
    placement="top"
    title="De wachtwoordvereisten zijn:">
        <span :class="passwordMinimalChars">- Minimaal 8 tekens.</span><br>
        <span :class="passwordMinimalCapitalLetter">- Minimaal 1 hoofdletter</span><br>
        <span :class="passwordMinimalNumber">- Minimaal 1 cijfer.</span><br>
        <span :class="passwordMinimalSpecial">- Minimaal 1 speciaal karakter (@, $,!, %, *, ? of &)</span>
    </b-popover>
</div>
</template>

<script>
export default {
    props: {
        'value': {
            type: String,
            required: true
        },
        'name': {
            type: String,
            required: true
        },
        'required': {
            type: String,
            required: true
        }
    },
    data () {
        return {
            password: this.value, // set the password equal to the given v-model
            passwordMinimalChars: {
                active: true,
                'text-danger': true
            },
            passwordMinimalCapitalLetter: {
                active: true,
                'text-danger': true
            },
            passwordMinimalNumber: {
                active: true,
                'text-danger': true
            },
            passwordMinimalSpecial: {
                active: true,
                'text-danger': true
            }
        }
    },
    watch: {
        password: function () {
            if (this.password.length < 8) {
                this.passwordMinimalChars['text-danger'] = true
                this.passwordMinimalChars['text-success'] = false
            } else {
                this.passwordMinimalChars['text-danger'] = false
                this.passwordMinimalChars['text-success'] = true
            }
            if (/[A-Z]/.test(this.password)) {
                this.passwordMinimalCapitalLetter['text-danger'] = false
                this.passwordMinimalCapitalLetter['text-success'] = true
            } else {
                this.passwordMinimalCapitalLetter['text-danger'] = true
                this.passwordMinimalCapitalLetter['text-success'] = false
            }
            if (/[0-9]/.test(this.password)) {
                this.passwordMinimalNumber['text-danger'] = false
                this.passwordMinimalNumber['text-success'] = true
            } else {
                this.passwordMinimalNumber['text-danger'] = true
                this.passwordMinimalNumber['text-success'] = false
            }

            if (/[@,$,!,%,*,?,&]/.test(this.password)) {
                this.passwordMinimalSpecial['text-danger'] = false
                this.passwordMinimalSpecial['text-success'] = true
            } else {
                this.passwordMinimalSpecial['text-danger'] = true
                this.passwordMinimalSpecial['text-success'] = false
            }

            // on update, send the input event to the parent component so it can update it's password value
            this.$emit('input', this.password)
        }
    },
    methods: {
        validateInput: function (inputModel, pattern) {
            if (inputModel.length > 0) {
                return pattern.test(inputModel) ? 'is-valid' : 'is-invalid'
            } else {
                return ''
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Global/Passwordfield.vue